import { useEffect } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { authState } from '../../../services/state/auth-state.jsx';

const AdminWrapper = () => {
  const { isAdmin } = useSnapshot(authState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      navigate('/', { replace: true });
    }
  }, []);

  return <Outlet />;
};

export default AdminWrapper;
